import React from 'react';
import iconPaths from '../../../../selection.json'; // the file exported from IcoMoon

function getPaths(iconName, color, showHoverStyle = false, overrideHoveredColor = false) {
  const icon = iconPaths.icons.find((icon) => icon.properties.name === iconName);

  // If overrideHoveredColor is passed in with showHoverStyle, that specified
  // color will be the color rendered when hovered (no opacity correction). The
  // else statement preserves the original hover pathStyle i.e. opacity correction
  // is rendered on hover.
  if (icon) {
    return icon.icon.paths.map((path, index) => {
      let pathStyle = {};
      if (showHoverStyle && overrideHoveredColor) {
        pathStyle = {
          fill: overrideHoveredColor,
        };
      } else {
        pathStyle = {
          fill: color || icon.icon.attrs[index].fill,
          fillOpacity: showHoverStyle ? 0.6 : 1,
        };
      }
      return <path key={index} style={pathStyle} d={path} />;
    });
  } else {
    console.warn(`icon ${iconName} does not exist.`);
    return '';
  }
}

//https://medium.com/@david.gilbertson/icons-as-react-components-de3e33cb8792
export default function IconView(props) {
  const {
    style = {}, // extra styling
    name,
    color,
    size = 22,
    overrideWidth,
    overrideHeight,
    overrideHoveredColor,
    isFlipped = false,
    rotation,
    isHovered = false,
    userHoverStyle = false,
  } = props;

  const flippedStyle = isFlipped
    ? {
        WebkitTransform: 'scaleX(-1)',
        MozTransform: 'scaleX(-1)',
        OTransform: 'scaleX(-1)',
        transform: 'scaleX(-1)',
      }
    : {};

  const rotationStyle = rotation
    ? {
        WebkitTransform: `rotate(${rotation})`,
        MozTransform: `rotate(${rotation})`,
        OTransform: `rotate(${rotation})`,
        transform: `rotate(${rotation})`,
      }
    : {};

  const svgStyle = {
    display: 'inline-block',
    verticalAlign: 'middle',
    ...flippedStyle,
    ...rotationStyle,
    ...style,
  };

  return (
    <svg
      style={svgStyle}
      width={`${overrideWidth || size}px`}
      height={`${overrideHeight || size}px`}
      viewBox="0 0 1024 1024">
      {getPaths(name, color, isHovered && userHoverStyle, overrideHoveredColor)}
    </svg>
  );
}
